/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles'
import { Paper, Typography, IconButton } from '@material-ui/core'

import add from "date-fns/add"
import DateFnsUtils from '@date-io/date-fns'; 
import { DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import { format, isSameDay, isWithinInterval } from 'date-fns'

const styles = theme => ({
    selected_day : {

    }
})

class DayRangePicker extends Component {
    state = {  }

    getMaxDate = () => {
        if (this.props.filter.start_date !== null) {
            let max_date = add(new Date(this.props.filter.start_date), {
                years: 0,
                months: 0,
                weeks: 0,
                days: 44,
                hours: 0,
                minutes: 0,
                seconds: 0,
            })
            console.log("Max Date :", max_date)
            return max_date
        }
    }

    updateValue = (date, position) => {
        let value =  format(date, "yyyy-MM-dd'T'HH:mm:ssxxx")
        this.props.update_filter(position, value)
    }

    render() {
        const {classes} = this.props
        return (
            <Fragment>
                <Typography style = {{marginLeft : '5px'}} variant = 'caption' color = 'secondary'><em>Maximum daily interval allowed is 45 days</em></Typography>
                <div style = {{display : 'flex', flexDirection : 'row'}}>
                    <div style = {{margin : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>From</Typography>
                        <Paper square elevation = {2}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    autoOk
                                    orientation="landscape"
                                    variant="static"
                                    openTo="date"
                                    value = {this.props.filter.start_date}
                                    onChange = {(value) => this.updateValue(value, 'start_date')}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </div>
                    <div style = {{margin : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>To</Typography>
                        <Paper square elevation = {2}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    autoOk
                                    orientation="landscape"
                                    variant="static"
                                    openTo="date"
                                    minDate = {new Date(this.props.filter.start_date)}
                                    maxDate = {this.getMaxDate()}
                                    disableFuture
                                    value = {this.props.filter.end_date}
                                    onChange = {(value) => this.updateValue(value, 'end_date')}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withStyles(styles)(DayRangePicker);